import { Injectable } from "@angular/core";
import {
  HttpErrorResponse,
  HttpEvent,
  HttpEventType,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { tap, catchError } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class HttpSizeInterceptor implements HttpInterceptor {
  // Define el tamaño máximo permitido (en bytes)
  private readonly maxRequestSize = 5000000; // 5 MB

  constructor(private translateService: TranslateService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const requestClone = req.clone();

    const requestSize = this.estimateRequestSize(requestClone);

    if (requestSize > this.maxRequestSize) {
      return throwError(this.getError());
    }

    return next.handle(requestClone).pipe(
      tap((event) => {
        const requestSize = this.estimateRequestSize(requestClone);

        if (requestSize > this.maxRequestSize) {
          return throwError(this.getError());
        }
      })
    );
  }

  private estimateRequestSize(request: HttpRequest<any>): number {
    let size = 0;

    size += new TextEncoder().encode(request.url).length;

    request.headers.keys().forEach((key) => {
      size += new TextEncoder().encode(key).length;
      size += new TextEncoder().encode(request.headers.get(key) || "").length;
    });

    if (request.body) {
      if (request.body instanceof FormData) {
        request.body.forEach((value, key) => {
          size += new TextEncoder().encode(key).length;
          if (typeof value === "string") {
            size += new TextEncoder().encode(value).length;
          } else if (value instanceof Blob) {
            size += value.size;
          }
        });
      } else if (typeof request.body === "object") {
        size += new TextEncoder().encode(JSON.stringify(request.body)).length;
      } else if (typeof request.body === "string") {
        size += new TextEncoder().encode(request.body).length;
      }
    }

    return size;
  }

  private getError(): HttpErrorResponse {
    let message: string = this.translateService.instant(
      "errorsInterceptor.requestSizeExceeded"
    );
    let err: HttpErrorResponse = {
      error: {
        mensaje: message,
      },
      type: HttpEventType.ResponseHeader,
      name: "HttpErrorResponse",
      message: "",
      ok: false,
      headers: new HttpHeaders(),
      status: 413,
      statusText: "",
      url: "",
    };
    return err;
  }
}
